import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { verifyGoogleRecaptchaToken } from '../../services/recaptcha'
import { REACT_APP_FEATURE_FLAG_RECAPTCHA_ENABLED } from '../../config/settings/environment'

export const GET_GOOGLE_RECAPTCHA_TOKEN = 'GET_GOOGLE_RECAPTCHA_TOKEN'
export const GET_GOOGLE_RECAPTCHA_TOKEN_ERROR = 'GET_GOOGLE_RECAPTCHA_TOKEN_ERROR'
export const GET_GOOGLE_RECAPTCHA_TOKEN_SUCCESS = 'GET_GOOGLE_RECAPTCHA_TOKEN_SUCCESS'
export const onGetGoogleRecaptchaToken = makeActionCreator(GET_GOOGLE_RECAPTCHA_TOKEN)
export const onGetGoogleRecaptchaTokenError = makeActionCreator(GET_GOOGLE_RECAPTCHA_TOKEN_ERROR, 'payload')
export const onGetGoogleRecaptchaTokenSuccess = makeActionCreator(GET_GOOGLE_RECAPTCHA_TOKEN_SUCCESS, 'payload')
export const onGetGoogleRecaptchaTokenThunk =
  ({ executeRecaptcha = () => undefined, skipped = false, onSuccessCallback = () => undefined }) =>
  async dispatch => {
    if (!(REACT_APP_FEATURE_FLAG_RECAPTCHA_ENABLED === true || REACT_APP_FEATURE_FLAG_RECAPTCHA_ENABLED === 'true')) {
      return onSuccessCallback()
    }
    dispatch(onGetGoogleRecaptchaToken())

    try {
      const token = await executeRecaptcha()

      if (skipped) {
        return dispatch(onGetGoogleRecaptchaTokenSuccess({ token }))
      }

      return () => {
        dispatch(onGetGoogleRecaptchaTokenSuccess({ token }))
        dispatch(onVerifyGoogleRecaptchaTokenThunk({ token, onSuccessCallback }))
      }
    } catch (error) {
      if (error?.originalError?.code === 'ERR_CANCELED') {
        return
      }

      return dispatch(
        onGetGoogleRecaptchaTokenError({
          error: customizeError({
            originalError: error?.originalError,
            code: error?.code,
            reason: 'GOOGLE_RECAPTCHA_ERROR'
          }).toObject()
        })
      )
    }
  }

export const VERIFY_GOOGLE_RECAPTCHA_TOKEN = 'VERIFY_GOOGLE_RECAPTCHA_TOKEN'
export const VERIFY_GOOGLE_RECAPTCHA_TOKEN_ERROR = 'VERIFY_GOOGLE_RECAPTCHA_TOKEN_ERROR'
export const VERIFY_GOOGLE_RECAPTCHA_TOKEN_SUCCESS = 'VERIFY_GOOGLE_RECAPTCHA_TOKEN_SUCCESS'
export const onVerifyGoogleRecaptchaToken = makeActionCreator(VERIFY_GOOGLE_RECAPTCHA_TOKEN)
export const onVerifyGoogleRecaptchaTokenError = makeActionCreator(VERIFY_GOOGLE_RECAPTCHA_TOKEN_ERROR, 'payload')
export const onVerifyGoogleRecaptchaTokenSuccess = makeActionCreator(VERIFY_GOOGLE_RECAPTCHA_TOKEN_SUCCESS, 'payload')
export const onVerifyGoogleRecaptchaTokenThunk =
  ({ token, onSuccessCallback = () => undefined }) =>
  async dispatch => {
    dispatch(onGetGoogleRecaptchaToken())

    try {
      const data = await verifyGoogleRecaptchaToken({
        actionType: VERIFY_GOOGLE_RECAPTCHA_TOKEN,
        token
      })

      return () => {
        dispatch(
          onVerifyGoogleRecaptchaTokenSuccess({
            hostName: data?.payload?.tokenProperties?.hostname,
            score: data?.payload?.riskAnalysis?.score
          })
        )
        onSuccessCallback(token)
      }
    } catch (error) {
      if (error?.originalError?.code === 'ERR_CANCELED') {
        return
      }

      let reason
      switch (error?.code) {
        case 400:
          if (error?.originalError?.response?.data?.errores[0]?.codigo === '400-1') {
            reason = 'GOOGLE_RECAPTCHA_ERROR'
          } else {
            reason = 'SOMETHING_WENT_WRONG_ERROR'
          }
          break
        default:
          reason = 'SOMETHING_WENT_WRONG_ERROR'
          break
      }

      return dispatch(
        onVerifyGoogleRecaptchaTokenError({
          error: customizeError({
            originalError: error?.originalError,
            code: error.code,
            reason
          }).toObject()
        })
      )
    }
  }
